import React, { useEffect, useState } from 'react';
import CommonModal from './CommonModal';

/**
 * Ad-hoc staff-entered discount (percentage or flat dollar amount) against the order's
 * gross total - independent of any pre-configured Offer/voucher. Resets to a blank
 * percentage entry every time it's opened, rather than remembering the last value
 * typed, so re-opening it never silently re-submits a stale number.
 */
const ApplyDiscountModal = ({ isOpen, onClose, onApply, applying }) => {
  const [type, setType] = useState('percent');
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setType('percent');
      setValue('');
    }
  }, [isOpen]);

  const numericValue = Number(value);
  const isValid = value !== '' && !isNaN(numericValue) && numericValue > 0;

  const handleApply = () => {
    if (!isValid) return;
    onApply(type, numericValue);
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="applyDiscountModal">
      <div className="modal-header">
        <h1 className="modal-title mdTitle" id="applyDiscountModalLabel">Apply Discount</h1>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <div className="modalBodyStyle">
          <div className="mb-3 d-flex gap-4">
            <div className="form-check">
              <input
                type="radio"
                className="form-check-input"
                id="discountTypePercent"
                name="manualDiscountType"
                checked={type === 'percent'}
                onChange={() => setType('percent')}
              />
              <label className="form-check-label" htmlFor="discountTypePercent">Percentage (%)</label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                className="form-check-input"
                id="discountTypeFlat"
                name="manualDiscountType"
                checked={type === 'flat'}
                onChange={() => setType('flat')}
              />
              <label className="form-check-label" htmlFor="discountTypeFlat">Flat Amount ($)</label>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">
              {type === 'percent' ? 'Discount Percentage' : 'Discount Amount'}
            </label>
            <input
              type="number"
              min="0"
              step="0.01"
              className="form-control"
              placeholder={type === 'percent' ? 'e.g. 10' : 'e.g. 15.00'}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              disabled={applying}
              autoFocus
            />
          </div>
        </div>
      </div>

      <div className="modal-footer justify-content-between">
        <button type="button" className="btn btnLight" onClick={onClose}>Close</button>
        <button
          type="button"
          className="btn btnPrimary"
          onClick={handleApply}
          disabled={applying || !isValid}
        >
          {applying ? 'Applying...' : 'Apply Discount'}
        </button>
      </div>
    </CommonModal>
  );
};

export default ApplyDiscountModal;
